import React from 'react';

import styled from '@emotion/styled';

import { COLORS, SANS_SERIF_FONT_FAMILY, mq } from '@clutter/clean';

import { useFunnelEntryPointContext } from '@shared/use_funnel_entry_point_context';

import errorIcon from './nav_bar_images/error.svg';

const ToastCard = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 12px;
  background: ${COLORS.flower};
  padding: 12px 18px;
  border-radius: 12px;
  font-family: ${SANS_SERIF_FONT_FAMILY};
  font-size: 16px;
  line-height: 24px;
  color: ${COLORS.sunset};
`;

const CenteredRow = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  ${mq({ padding: ['0 12px', '0 16px'] })}
`;

const TopToastPositioner = styled.div`
  position: fixed;
  left: 0;
  right: 0;
  top: 80px; /* just below 72px navbar with a little breathing room */
  z-index: 450;
  pointer-events: none; /* let clicks through unless on the toast */

  /* subtle slide + fade in */
  transition:
    opacity 160ms ease-out,
    transform 160ms ease-out;
`;

export const TopZipToast: React.FC = () => {
  const { errorMessage } = useFunnelEntryPointContext();
  if (!errorMessage) return null;

  return (
    <TopToastPositioner aria-live="assertive" role="status">
      <CenteredRow>
        <div
          style={{
            maxWidth: 566,
            width: '100%',
            pointerEvents: 'auto',
            display: 'flex',
            justifyContent: 'center',
          }}
        >
          <ToastCard>
            <img src={errorIcon} width={20} height={20} alt="" />
            <div>{errorMessage}</div>
          </ToastCard>
        </div>
      </CenteredRow>
    </TopToastPositioner>
  );
};

const InlineToastWrapper = styled.div`
  width: 100%;
  margin: 12px 0 0;
  display: flex;
  justify-content: center;
`;

export const InlineZipToast: React.FC = () => {
  const { errorMessage } = useFunnelEntryPointContext();
  if (!errorMessage) return null;

  return (
    <InlineToastWrapper aria-live="assertive" role="status">
      <div
        style={{
          maxWidth: 566,
          width: '100%',
          display: 'flex',
          justifyContent: 'center',
        }}
      >
        <ToastCard>
          <img src={errorIcon} width={20} height={20} alt="" />
          <div>{errorMessage}</div>
        </ToastCard>
      </div>
    </InlineToastWrapper>
  );
};
